<template>
  <div v-if="extra.getSkills().length > 0" class="extra-skills-component">
    <h2>{{ $t('ETAB.PAGES.EXTRA.@SKILLS_TITLE') }}</h2>
    <section>
      <ExtraRoundedTag
v-for="(skill, index) in extra.getSkills()"
                       :key="skill.getLabel()+'_'+index"
                       :label="skill.getLabel()"
                       background="primary"
                       color="white"
      />
    </section>
  </div>
</template>

<script>
import { ExtraModel } from "@core/models";

export default {
  props: {
    extra: {
      type: Object,
      default: () => new ExtraModel(),
    },
  },
};
</script>

<style lang="scss">
.extra-skills-component {
  margin-top: 35px;
  color: $primary;

  h2 {
    margin: 0;
  }

  > section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 15px 0;
  }
}
</style>
